import { Component } from '@angular/core';

@Component({
  selector: 'gp-idle-timeout-modal',
  templateUrl: './idle-timeout-modal.component.html',
  styleUrls: ['./idle-timeout-modal.component.scss']
})
export class IdleTimeoutModalComponent {

  public remainingSeconds: number;

  public logout() {
    // Intentionally empty
  }

  public keepSession() {
    // Intentionally empty
  }

}
